export const getSafeVoyageName = (name: string): string => {
  const sanitized = name?.includes(":")
    ? name?.replace(/\s+/g, "_").replace(/:/g, "-")
    : name?.replace(/ - /g, "-").replace(/\s+/g, "-");

  return sanitized;
};
